import {  formatDate, formatGender, formatSmoker, getCountryName, getFrecuencyLabel, USD_PREFIX } from "../../../../../utils/utils";
import { ConfirmationData, LastQuote, QuoteSelected, updateMapWithFields2 } from "../../../../common/summary-common/confirmationData";

export const defaultCoverageInformation: Map<string, ConfirmationData> = new Map([
    ["gender", { label: "Gênero", fontWeight: "bold", showBorder: true }],
    ["smoker", { label: "Status de fumante", fontWeight: "bold", showBorder: true }],
    ["country", { label: "País", fontWeight: "bold", showBorder: true }],
    ["dob", { label: "Data de nascimento", fontWeight: "bold", showBorder: true }],
    ["term_selected", { label: "Prazo", fontWeight: "bold", showBorder: true }],
    ["total_premium", { label: "Prêmio a pagar", fontWeight: "bold", showBorder: true }],
    ["frecuency", { label: "Frequência de pagamento", fontWeight: "bold", showBorder: true }],
    ["Cobertura principal", { label: "Cobertura principal", fontWeight: "bold", coverageLabel: "Cobertura principal", value: "Valor segurado", premium: "Prêmio", coverageClassName: "confirmation-row__coverage--compact" }],
    ["policy_amount", { label: "Benefício por morte", showBorder: false, fontWeight: "bold" }],
    ["Coberturas adicionais", { label: "Coberturas adicionais", fontWeight: "bold", coverageLabel: "Coberturas adicionais", value: "Valor segurado", premium: "Prêmio", hidden: true, coverageClassName: "confirmation-row__coverage--compact" }],
    ["ad_amount", { label: "Morte Acidental", showBorder: false, fontWeight: "bold", hiddenIfEmpty: true }],
    ["tpd_amount", { label: "Invalidez Permanente Total por Acidente Pessoal", showBorder: false, fontWeight: "bold", hiddenIfEmpty: true }],
//     ["Beneficios en vida", { label: "Beneficios en vida", fontWeight: "bold", coverageLabel: "Beneficios en vida", value: "Valor segurado" }],
//    // ["protection_amount", { label: "Pago anticipado por enfermedad terminal", showBorder: true, fontWeight: "bold" }],
//     ["add_amount", { label: "Pago anticipado por incapacidad o muerte accidental", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],
//     ["rop_amount", { label: "Retorno de Prima", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],
//     ["permanent_disability", { label: "Protección de ingreso por incapacidad total permanente", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],
//     ["temporary_total_disability", { label: "Protección de ingreso por incapacidad total temporal", showBorder: true, fontWeight: "bold", hiddenIfEmpty: true }],

]);

export const updateCoverageInformation = (selected: QuoteSelected, lastQuote: LastQuote, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
const formatAmount = (amount: number | undefined): string =>
        amount !== undefined ? `${USD_PREFIX}${amount.toLocaleString('de-DE')}` : "";
    const baseFields: Array<[string, string | null]> = [
        ["gender", formatGender(selected?.gender || "", "pt")],
        ["smoker", formatSmoker(selected?.smoker, "pt")],
        ["country", getCountryName(selected?.country || "")],
        ["dob", formatDate(selected?.lead?.date_of_birth || "", "pt", false)],
        ["annual_income", formatAmount(selected?.annual_income)],
        ["product_type", selected?.product_type ? (selected.product_type === "easy_term" ? "Easy Term" : "Master Term") : ""],
        ["term_selected", selected?.term_selected ? `${selected.term_selected} anos` : null],
        ["total_premium", formatAmount(lastQuote?.total_premium_in_frecuency)],
        ["frecuency", selected?.frecuency_selected ? getFrecuencyLabel(selected.frecuency_selected, "pt") : ""],
        ["policy_amount", formatAmount(selected?.policy_amount)],
        ["ad_amount", selected?.ad_amount ? formatAmount(selected.ad_amount) : ""],
        ["tpd_amount", selected?.tpd_amount ? formatAmount(selected.tpd_amount) : ""],
        // ["protection_amount", (() => {
        //     const policyAmount = selected?.policy_amount || 0;
        //     if (policyAmount >= 1000000) {
        //         return formatAmount(500000);
        //     } else {
        //         return formatAmount(Math.min(policyAmount / 2, 250000));
        //     }
        // })()],
    ];

    if (lastQuote?.income_replacement?.temporary_total_disability > 0) {
        baseFields.push(["temporary_total_disability", `Hasta ${formatAmount(lastQuote.income_replacement.temporary_total_disability)} por mes`]);
    }

    if (lastQuote?.income_replacement?.permanent_disability > 0) {
        baseFields.push(["permanent_disability", formatAmount(lastQuote.income_replacement.permanent_disability)]);
    }

    if (selected?.add_amount) {
        baseFields.push(["add_amount", formatAmount(selected?.add_amount)]);
    }


    if (lastQuote?.rop_amount && selected?.rop) {
        baseFields.push(["rop_amount", formatAmount(lastQuote?.rop_amount) + " (Monto de retorno)"]);
    }

    const result = updateMapWithFields2(baseFields, cd, false);

    const premiumByKey: Array<[string, number | undefined]> = [
        ["policy_amount", lastQuote?.coverage_premium],
        ["ad_amount", lastQuote?.rider_optional_total_ad],
        ["tpd_amount", lastQuote?.rider_optional_total_tpd],
    ];
    premiumByKey.forEach(([key, amount]) => {
        if (amount === undefined) return;
        const item = result.get(key);
        if (item) {
            result.set(key, { ...item, premium: formatAmount(amount) });
        }
    });

    if (lastQuote?.coverage_premium === undefined) {
        ["Cobertura principal", "Coberturas adicionais"].forEach((key) => {
            const item = result.get(key);
            if (item?.premium !== undefined) {
                result.set(key, { ...item, premium: undefined });
            }
        });
    }

    const hasAdditionalCoverages =
        (selected?.ad_amount != null && selected.ad_amount > 0) ||
        (selected?.tpd_amount != null && selected.tpd_amount > 0);

    const coberturasItem = result.get("Coberturas adicionais");
    if (coberturasItem) {
        result.set("Coberturas adicionais", { ...coberturasItem, hidden: !hasAdditionalCoverages });
    }

    const policyAmountItem = result.get("policy_amount");
    if (policyAmountItem) {
        result.set("policy_amount", { ...policyAmountItem, showBorder: hasAdditionalCoverages });
    }

    return result;
};